import { useState } from "react";
import { Search, Loader2, CheckCircle2, Hourglass } from "lucide-react";
import { giftStatus, errorDetail } from "@/lib/reader";

export default function GiftStatusCheck() {
  const [code, setCode] = useState("");
  const [busy, setBusy] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const check = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    setResult(null);
    try {
      setResult(await giftStatus(code.trim()));
    } catch (err) {
      setError(errorDetail(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mt-14 border-t border-white/10 pt-10 max-w-xl" data-testid="gift-status-check">
      <p className="font-mono-ui text-xs uppercase tracking-[0.25em] text-primary-gold">Already sent a gift?</p>
      <h2 className="font-serif-display text-2xl sm:text-3xl mt-3">Check if it's been redeemed</h2>
      <form onSubmit={check} className="flex flex-col sm:flex-row gap-3 mt-6">
        <input
          value={code}
          onChange={(e) => setCode(e.target.value)}
          placeholder="GIFT-XXXX-XXXX"
          required
          data-testid="gift-status-input"
          className="flex-1 bg-[#0B0C10] border border-white/15 px-4 py-3 font-mono-ui text-sm uppercase tracking-[0.15em] focus:outline-none focus:border-primary-gold"
        />
        <button type="submit" disabled={busy} data-testid="gift-status-submit" className="btn-ghost px-6 py-3 font-mono-ui text-xs uppercase tracking-[0.18em] flex items-center justify-center gap-2">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Search className="w-4 h-4" />} Check
        </button>
      </form>
      {error && <p className="mt-4 text-sm text-[#d6453a]" data-testid="gift-status-error">{error}</p>}
      {result && (
        <div className="mt-5 flex items-start gap-3 border border-white/10 bg-[#121212] px-5 py-4" data-testid="gift-status-result">
          {result.redeemed ? <CheckCircle2 className="w-5 h-5 text-[#4ade80] shrink-0" /> : <Hourglass className="w-5 h-5 text-[#e0982f] shrink-0" />}
          <p className="text-sm">
            <span className="font-mono-ui">{result.code}</span>{" "}
            {result.redeemed
              ? <>was redeemed on <strong>{new Date(result.redeemed_at).toLocaleDateString()}</strong> — your friend is reading!</>
              : <>hasn't been redeemed yet. It never expires, so a gentle nudge might help.</>}
          </p>
        </div>
      )}
    </div>
  );
}
